import Icon from '@mdi/react';
import { mdiFire, mdiOpenInNew } from '@mdi/js';
import { makeStyles, Theme, Tooltip } from '@material-ui/core';
import { sidebarConfig, useSidebarOpenState } from '@backstage/core-components';
import { MENU_ITEM_HEIGHT } from './ExpandableSidebarGroup/constants';

const INCIDENT_ORANGE = '242, 85, 51';

const useStyles = makeStyles<Theme>(theme => ({
  link: {
    display: 'flex',
    alignItems: 'center',
    height: MENU_ITEM_HEIGHT,
    padding: 0,
    paddingRight: 30,
    textDecoration: 'none',
    color: theme.palette.navigation.color,
    transition: 'background-color 150ms ease',
    '&:hover': {
      backgroundColor:
        theme.palette.navigation.navItem?.hoverBackground ?? '#404040',
    },
    '&:hover $externalIcon': {
      color: `rgb(${INCIDENT_ORANGE})`,
      opacity: '1',
    },
  },
  linkCollapsed: {
    justifyContent: 'center',
    paddingRight: 0,
  },
  iconContainer: {
    position: 'relative',
    boxSizing: 'border-box',
    width: sidebarConfig.drawerWidthClosed,
    minWidth: sidebarConfig.drawerWidthClosed,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  iconContainerExpanded: {
    marginRight: -theme.spacing(2),
  },
  flameIcon: {
    color: `rgb(${INCIDENT_ORANGE})`,
    flexShrink: 0,
  },
  text: {
    flex: 1,
    minWidth: 0,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    fontWeight: 'bold',
    fontSize: theme.typography.fontSize,
    color: theme.palette.navigation.color,
  },
  externalIcon: {
    color: theme.palette.navigation.color,
    flexShrink: 0,
    opacity: 0.7,
    transition: 'color 150ms ease, opacity 150ms ease',
    marginLeft: 'auto',
  },
}));

/**
 * A link component for navigating to incident.io, styled to match regular sidebar items.
 * Adapts to sidebar collapsed state by hiding text and centering the icon.
 */
export function SidebarIncidentLink() {
  const classes = useStyles();
  const { isOpen } = useSidebarOpenState();

  return (
    <Tooltip
      title="Open incident.io in a new tab"
      placement="top"
      enterDelay={500}
    >
      <a
        href="https://app.incident.io/"
        target="_blank"
        rel="noopener noreferrer"
        className={`${classes.link} ${!isOpen ? classes.linkCollapsed : ''}`}
      >
        <div
          className={`${classes.iconContainer} ${isOpen ? classes.iconContainerExpanded : ''}`}
        >
          <Icon path={mdiFire} className={classes.flameIcon} size="24px" />
        </div>
        {isOpen && (
          <>
            <span className={classes.text}>Incidents</span>
            <Icon
              path={mdiOpenInNew}
              className={classes.externalIcon}
              size="14px"
            />
          </>
        )}
      </a>
    </Tooltip>
  );
}
